const convertToCamelCase = (str: string): string =>
  str.replace(/_([a-z])/g, (g) => g[1].toUpperCase());

export const formatObjectKeysToCamelCase = (obj: { [x: string]: any } = {}) =>
  Object.keys(obj).reduce((finalObj: { [x: string]: any }, key: string) => {
    // eslint-disable-next-line no-param-reassign
    finalObj[convertToCamelCase(key)] = obj[key];
    return finalObj;
  }, {});
